import {FormProps, Option} from 'platform/components';

import {always, times} from 'ramda';

import {GetOrderSetDefaultContactPersonApiResponse} from '@dms/api/core';
import {CustomerResponseBodyV2} from '@dms/api/customer';
import {PhoneNumber} from '@dms/api/shared';

import {isNotNilOrEmpty, Nullish} from 'shared/web';

import {getNaturalPersonFullName} from '../../../utils/getNaturalPersonFullName';
import {EMPTY_WHEEL} from '../constants/emptyWheel';
import {TireSetDetailFormDefinition} from '../types/TireSetDetailFormDefinition';

export const getDraftTireSetDefaultValues = (
  tireCategoryId: string | Nullish,
  locationOptions: Option[],
  defaultStoreUntil: string | Nullish,
  defaultManufacturerId: string | Nullish,
  defaultContactPerson: GetOrderSetDefaultContactPersonApiResponse,
  tenantPhoneInfo: PhoneNumber,
  customerData: CustomerResponseBodyV2 | Nullish,
  defaultTireConditionId: string | Nullish
): FormProps<TireSetDetailFormDefinition>['defaultValues'] => {
  const customerInfo = customerData?.foundingPerson ?? customerData?.contacts?.[0];

  const name =
    getNaturalPersonFullName(customerInfo) ?? defaultContactPerson?.contactInformation?.name;

  return {
    numberOfTires: 4,
    categoryId: tireCategoryId,
    storedUntil: defaultStoreUntil,
    isReplacement: false,
    tireSetRequestEnabled: false,
    wheels: times(always(EMPTY_WHEEL), 4).map((wheel, index) => ({
      ...wheel,
      manufacturer: defaultManufacturerId,
      location: locationOptions?.[index % locationOptions?.length]?.value,
      tireCondition: defaultTireConditionId,
      hasHubcap: wheel.hasHubcap ?? false,
      hasWheelLocks: wheel.hasWheelLocks ?? false,
    })),
    contactInformation: isNotNilOrEmpty(defaultContactPerson?.contactInformation)
      ? {
          id: defaultContactPerson?.contactInformation?.id,
          name,
          email: defaultContactPerson?.contactInformation?.email,
          phoneNumber: {
            countryCode:
              defaultContactPerson?.contactInformation?.phoneNumber?.countryCode ??
              tenantPhoneInfo.countryCode,
            number:
              defaultContactPerson?.contactInformation?.phoneNumber?.number ??
              tenantPhoneInfo.number,
            prefix:
              defaultContactPerson?.contactInformation?.phoneNumber?.prefix ??
              tenantPhoneInfo.prefix,
          },
        }
      : {
          phoneNumber: {
            countryCode: tenantPhoneInfo.countryCode,
            number: tenantPhoneInfo.number,
            prefix: tenantPhoneInfo.prefix,
          },
        },
  };
};
